(function () {
  if (window.__AJP_ZEPTO_LABEL_CLEANER__) return;
  window.__AJP_ZEPTO_LABEL_CLEANER__ = true;

  function $(sel, ctx){return (ctx||document).querySelector(sel)}
  function $all(sel, ctx){return (ctx||document).querySelectorAll(sel)}
  function isVisible(el){
    if(!el) return false;
    var cs=getComputedStyle(el);
    if(cs.display==='none'||cs.visibility==='hidden'||cs.opacity==='0') return false;
    if(el.offsetParent===null && cs.position!=='fixed') return false;
    return true;
  }
  function climbWrapper(el){
    while(el && el.nodeType===1){
      if(el.classList && el.classList.contains('pplr-wrapper')) return el;
      el = el.parentNode;
    }
    return null;
  }

  function getVisibleUploadLabels() {
    var inputs = $all(
      '.pplrfileuploadbutton input[type="file"][name^="properties[Upload Photo ("]' +
      ', .pplrfileuploadbutton input[type="file"][name^="properties[Upload Image ("]'
    );
    var out=[];
    for (var i=0;i<inputs.length;i++){
      var wrap = climbWrapper(inputs[i]);
      if (!wrap || !isVisible(wrap)) continue;
      var label = wrap.querySelector('label.pplrlabel');
      if (label && isVisible(label)) out.push(label);
    }
    return out;
  }

  function cleanLabel(label){
    try{
      var span = label.querySelector('.pplr_option_price_span');
      var spanHTML = span ? span.outerHTML : '';
      // Only rewrite if it *looks* like “Upload … (CODE)”
      var txt = (label.textContent||'').replace(/\s+/g,' ').trim();
      if (!/(Upload\s+(Photo|Image))\s*\([^)]+\)/i.test(txt)) return false;
      // Rebuild visible content; keep the span
      label.innerHTML = (txt.match(/Upload\s+(Photo|Image)/i)||['','Upload Photo'])[0] + ' ' + spanHTML;
      return true;
    }catch(_){ return false; }
  }

  function cleanVisible(){
    var labels = getVisibleUploadLabels(), n=0;
    for (var i=0;i<labels.length;i++){ if (cleanLabel(labels[i])) n++; }
    if (n) { /* console.log('[AJP/Zepto] cleaned', n); */ }
  }

  // --- Detect Zepto presence, then wire listeners ---
  function hasZeptoRoot(){
    return $('[id^="pplr-"]') || $('.product-personalizer') || $("[class*='pplr-wrapper']");
  }

  function init(){
    if (!hasZeptoRoot()) return false;

    // Kick a few passes now (covers initial render + quick swaps)
    cleanVisible();
    setTimeout(cleanVisible, 80);
    setTimeout(cleanVisible, 240);

    // Re-run on typical interactions
    var t1,t2,t3;
    function schedule(){
      clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);
      t1 = setTimeout(cleanVisible, 0);
      t2 = setTimeout(cleanVisible, 120);
      t3 = setTimeout(cleanVisible, 400);
    }
    document.addEventListener('click', schedule, true);
    document.addEventListener('change', schedule, true);
    document.addEventListener('input', schedule, true);

    // Observe under Zepto root only (lighter than full document)
    var root = $('[id^="pplr-"]') || $('.product-personalizer') || document.body;
    if (window.MutationObserver && root){
      var obs = new MutationObserver(function(m){
        for (var i=0;i<m.length;i++){
          if (m[i].type==='childList' && (m[i].addedNodes&&m[i].addedNodes.length)){ schedule(); break; }
          if (m[i].type==='characterData'){ schedule(); break; }
        }
      });
      obs.observe(root, {childList:true, subtree:true, characterData:true});
    }
    return true;
  }

  // Wait for DOM then try; if Zepto mounts late, poll briefly
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    if (init()) return;
    var tries=0, max=20, iv=setInterval(function(){
      if (init() || ++tries>=max) clearInterval(iv);
    }, 150);
  });

  /* AJP – Zepto popular size marker + temporary size disables */
  (function () {
    if (window.__AJP_ZEPTO_POPULAR__) return;
    window.__AJP_ZEPTO_POPULAR__ = true;

    function hasZepto() {
      return document.querySelector('[id^="pplr-"]')
          || document.querySelector('.product-personalizer')
          || document.querySelector('.pplr-wrapper');
    }

    function markPopular() {
      if (!hasZepto()) return; // bail on non-Zepto products

      // Find the 1000pc radio
      var input = document.querySelector(
        'input[type="radio"][name="Size"][value="1000pc"], ' +
        'input[type="radio"][name="options[Size]"][value="1000pc"]'
      );
      if (!input) return;

      // Find its label
      var label = document.querySelector('label[for="' + input.id + '"]');
      if (!label) {
        // fallback: match by text content if for/id linkage changes
        var labels = document.querySelectorAll('label');
        for (var i = 0; i < labels.length; i++) {
          var txt = (labels[i].textContent || '').trim();
          if (txt === '1000pc') { label = labels[i]; break; }
        }
      }
      if (!label) return;

      // Add the marker class
      label.classList.add('zepto-popular');
    }

    // --- NEW: temporarily disable specific sizes (e.g., 100pc, 400pc) ---
    function disableSizes(values) {
      if (!hasZepto()) return;

      // helper to find a radio for a size value regardless of name
      function findRadio(val) {
        return document.querySelector(
          'input[type="radio"][name="Size"][value="' + val + '"], ' +
          'input[type="radio"][name="options[Size]"][value="' + val + '"]'
        );
      }

      // Disable requested sizes
      values.forEach(function (val) {
        var input = findRadio(val);
        if (!input) return;

        input.disabled = true;
        input.setAttribute('aria-disabled', 'true');
        input.classList.add('zepto-disabled-input');

        var label = document.querySelector('label[for="' + input.id + '"]');
        if (label) {
          label.classList.add('zepto-disabled');
          label.setAttribute('aria-disabled', 'true');
          // guard: in case theme doesn't respect radio disabled, block clicks
          label.addEventListener('click', function (e) { e.preventDefault(); }, { capture: true, once: false });
        }
      });

      // Safety: if current selection is now disabled, switch to first enabled option
      var selected = document.querySelector(
        'input[type="radio"][name="Size"]:checked, ' +
        'input[type="radio"][name="options[Size]"]:checked'
      );
      if (selected && selected.disabled) {
        var fallback = document.querySelector(
          'input[type="radio"][name="Size"]:not(:disabled), ' +
          'input[type="radio"][name="options[Size]"]:not(:disabled)'
        );
        if (fallback) {
          fallback.checked = true;
          // trigger native change so Shopify updates variant
          var evt = new Event('change', { bubbles: true });
          fallback.dispatchEvent(evt);
        }
      }
    }

    function init() {
      markPopular();
      //disableSizes(['100pc', '400pc']); // <-- set which sizes to disable
      //disableSizes(['100pc']); //GJ20260611: Configured, tested and launched 100pc //GJ20260615: Relaunched after HPSF issus resolved
      //disableSizes(['200pc']); //GJ20260611: Created the 200pc variant

      // Re-apply if Dawn re-renders the product section / variant picker
      var root = document.querySelector('[id^="MainProduct-"]')
              || document.getElementById('ProductInfo-template')
              || document; // last resort
      if (root && 'MutationObserver' in window) {
        var t;
        var obs = new MutationObserver(function () {
          clearTimeout(t);
          t = setTimeout(function () {
            markPopular();
            //disableSizes(['100pc', '400pc']);
            //disableSizes(['100pc']); //GJ20260611: Configured, tested and launched 100pc //GJ20260615: Relaunched after HPSF issus resolved
            //disableSizes(['200pc']); //GJ20260611: Created the 200pc variant
          }, 50);
        });
        obs.observe(root, { childList: true, subtree: true });
      }

      // Also try on common interactions
      function rerun() {
        markPopular();
        //disableSizes(['100pc', '400pc']);
        //disableSizes(['100pc']); //GJ20260611: Configured, tested and launched 100pc //GJ20260615: Relaunched after HPSF issus resolved
        //disableSizes(['200pc']); //GJ20260611: Created the 200pc variant
      }
      document.addEventListener('change', rerun, true);
      document.addEventListener('click', rerun, true);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();
})();
